var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSulphurDioxide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    "data-name": "Livello 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 652.17 652.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "335.63 327.56 335.63 426.36 420.52 475.37 505.75 426.17 505.75 327.76 420.52 278.55 335.63 327.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "146.42 327.76 146.42 426.17 231.64 475.37 316.54 426.36 316.54 327.56 231.64 278.55 146.42 327.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M647.23,270.02c-14.98-85.78-62.46-160.6-133.71-210.66C442.28,9.29,355.8-10.03,270.02,4.94c-85.78,14.98-160.6,62.46-210.66,133.71C9.29,209.89-10.03,296.37,4.94,382.15c14.98,85.78,62.46,160.6,133.71,210.66,55.51,39.01,120.27,59.36,186.74,59.36,18.84,0,37.82-1.64,56.76-4.94,85.78-14.98,160.6-62.46,210.66-133.71,50.07-71.24,69.39-157.72,54.42-243.5ZM343.54,118.78h22.54l19.73,27.82,19.36-27.82h21.45l-29.9,41.42,31.98,44.36h-22.91l-20.71-29.78-20.35,29.78h-22.79l31.74-43.63-30.14-42.15ZM302.49,162.4h34.68v15.32h-34.68v-15.32ZM222.84,118.78h64.82v15.93h-45.09v18.63h39.82v15.44h-39.82v19.85h46.69v15.93h-66.42v-85.78ZM524.51,437l-94.61,54.62v25.5h-18.76v-25.5l-85.06-49.11-85.06,49.11v25.5h-18.75v-25.5l-94.61-54.62v-120.07l94.61-54.63v-25.49h18.75v25.49l85.06,49.12,85.06-49.12v-25.49h18.76v25.49l94.61,54.63v120.07Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSulphurDioxide);
export default __webpack_public_path__ + "static/media/sulphurDioxide.497f98c91c8b51d5a15e1a4a07890b13.svg";
export { ForwardRef as ReactComponent };